/* AKAPELA — three-column garment showcase for Shopify (vanilla JS, no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // Theme toggle (all pages). Default: dark. Not persisted (no storage use).
  const tt = $('[data-theme-toggle]');
  if (tt) {
    let theme = document.documentElement.dataset.theme || 'dark';
    tt.addEventListener('click', () => {
      theme = theme === 'dark' ? 'light' : 'dark';
      document.documentElement.dataset.theme = theme;
      tt.setAttribute('aria-label', `Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`);
    });
  }

  const dataEl = $('#akapela-data');
  if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const FALLBACK_HEX = { onyx:'#0e0d0d', black:'#0e0d0d', bone:'#d8cfbc', cream:'#e8e0cf', white:'#f2f0ea', oxblood:'#5a1a22', burgundy:'#5a1a22', midnight:'#18233f', navy:'#18233f', grey:'#77746e', gray:'#77746e', olive:'#4a4d33', forest:'#22392b' };
  const hexFor = c => c.hex || FALLBACK_HEX[c.name.toLowerCase()] || '#777';

  const PRODUCTS = data.products.filter(p => p.colors.length && p.colors[0].image);
  if (!PRODUCTS.length) return;
  PRODUCTS.forEach((p, i) => { p.i = i; p.code = `Silhouette ${String(i + 1).padStart(2, '0')}`; });
  const N = PRODUCTS.length, wrap = i => (i + N) % N;
  const state = { i: 0, color: Object.fromEntries(PRODUCTS.map(p => [p.handle, p.colors[0].name])) };
  const colorOf = (p, name) => p.colors.find(c => c.name === name) || p.colors[0];
  const showcase = $('.showcase');
  const img = { l: $('[data-left-image]'), c: $('[data-center-image]'), r: $('[data-right-image]') };
  let busy = false;

  setTimeout(() => PRODUCTS.forEach(p => p.colors.forEach(c => { const im = new Image(); im.src = c.image; })), 400);

  function setSrc(el, src, alt, animate) {
    if (el.getAttribute('src') === src) { el.alt = alt; return; }
    if (!animate) { el.src = src; el.alt = alt; return; }
    el.classList.add('swap');
    const next = new Image();
    next.onload = next.onerror = () => setTimeout(() => { el.src = src; el.alt = alt; requestAnimationFrame(() => el.classList.remove('swap')); }, 120);
    next.src = src;
  }
  const status = (msg, warn) => { const m = $('[data-purchase-status]'); m.textContent = msg; m.classList.toggle('warn', !!warn); };

  function swatch(p, c, selected) {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'swatch'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', selected);
    b.setAttribute('aria-label', c.name); b.title = c.name; b.dataset.color = c.name;
    b.innerHTML = `<i style="--c:${hexFor(c)}"></i>`;
    b.addEventListener('click', () => { state.color[p.handle] = c.name; render(true); refreshZoom(); });
    return b;
  }

  function render(animate = false) {
    const p = PRODUCTS[state.i], L = PRODUCTS[wrap(state.i - 1)], R = PRODUCTS[wrap(state.i + 1)];
    const cName = state.color[p.handle], c = colorOf(p, cName);
    setSrc(img.c, c.image, `${p.title} in ${c.name}`, animate);
    setSrc(img.l, colorOf(L, state.color[L.handle]).image, '', animate);
    setSrc(img.r, colorOf(R, state.color[R.handle]).image, '', animate);
    $('[data-left-name]').textContent = L.title; $('[data-right-name]').textContent = R.title;
    $('[data-product-code]').textContent = p.code; $('[data-product-title]').textContent = p.title;
    $('[data-product-tagline]').textContent = p.tagline;
    $('[data-price]').textContent = p.price;
    $('[data-color-name]').textContent = c.name; $('[data-color-caption]').textContent = c.name;
    $('[data-focus-number]').textContent = String(state.i + 1).padStart(2, '0');
    $('[data-center-collection]').textContent = $('[data-center-collection]').textContent.replace(/\/ \d+$/, '/ ' + String(state.i + 1).padStart(3, '0'));
    $('[data-page-count]').textContent = `${String(state.i + 1).padStart(2, '0')} / ${String(N).padStart(2, '0')}`;
    const sw = $('[data-swatches]'); sw.innerHTML = '';
    if (p.colors.length > 1) p.colors.forEach(col => sw.appendChild(swatch(p, col, col.name === c.name)));
    // sizes available for the focused color
    const sizes = [...new Set(p.variants.map(v => v.size).filter(Boolean))];
    const sel = $('[data-size]'), keep = sel.value;
    sel.innerHTML = '<option value="">Size</option>' + sizes.map(s => {
      const v = p.variants.find(v => v.color === c.name && v.size === s);
      return `<option value="${s}" ${v && v.available ? '' : 'disabled'}>${s}${v && v.available ? '' : ' (sold out)'}</option>`;
    }).join('');
    sel.value = [...sel.options].some(o => o.value === keep && !o.disabled) ? keep : '';
    sel.parentElement.hidden = false;
    $('[data-details-title]').textContent = p.title; $('[data-details-description]').textContent = p.description;
    status('');
  }

  function go(dir) {
    if (busy || N < 2) return; busy = true;
    showcase.classList.add('shifting', dir > 0 ? 'shift-next' : 'shift-prev');
    setTimeout(() => {
      state.i = wrap(state.i + dir); render(true);
      showcase.classList.remove('shift-next', 'shift-prev');
      setTimeout(() => { showcase.classList.remove('shifting'); busy = false; }, 260);
    }, 220);
  }
  $$('[data-next]').forEach(b => b.addEventListener('click', e => { e.stopPropagation(); go(1); }));
  $$('[data-prev]').forEach(b => b.addEventListener('click', e => { e.stopPropagation(); go(-1); }));

  // Horizontal browsing: wheel/trackpad, keys, drag, swipe
  let wheelAcc = 0, wheelLock = 0;
  addEventListener('wheel', e => {
    if ($('dialog[open]')) return;
    // Sideways intent only (trackpad swipe, tilt wheel, or Shift + wheel). Plain vertical wheel scrolls the page.
    const sideways = Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey;
    if (!sideways) return;
    e.preventDefault();
    const d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    const now = performance.now(); if (now < wheelLock) { wheelAcc = 0; return; }
    wheelAcc += d; if (Math.abs(wheelAcc) > 60) { go(wheelAcc > 0 ? 1 : -1); wheelAcc = 0; wheelLock = now + 700; }
  }, { passive: false });
  function cycle(d) { const p = PRODUCTS[state.i], cs = p.colors, idx = cs.findIndex(c => c.name === state.color[p.handle]); state.color[p.handle] = cs[(idx + d + cs.length) % cs.length].name; render(true); refreshZoom(); }
  addEventListener('keydown', e => {
    if ($('dialog[open]') || /select|input|textarea/i.test(document.activeElement.tagName)) return;
    if (e.key === 'ArrowRight') go(1); if (e.key === 'ArrowLeft') go(-1);
    if (scrollY < 80) { if (e.key === 'ArrowUp') { e.preventDefault(); cycle(-1); } if (e.key === 'ArrowDown') { e.preventDefault(); cycle(1); } }
  });
  let sx = null, sy = 0, moved = false;
  showcase.addEventListener('pointerdown', e => { if (e.button) return; sx = e.clientX; sy = e.clientY; moved = false; });
  showcase.addEventListener('pointermove', e => { if (sx !== null && Math.abs(e.clientX - sx) > 8) { moved = true; showcase.classList.add('dragging'); } });
  addEventListener('pointerup', e => { if (sx === null) return; const dx = e.clientX - sx, dy = e.clientY - sy; sx = null; showcase.classList.remove('dragging'); if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1); });
  addEventListener('pointercancel', () => { sx = null; showcase.classList.remove('dragging'); });
  showcase.addEventListener('click', e => { if (moved) { e.stopImmediatePropagation(); e.preventDefault(); moved = false; } }, true);
  showcase.addEventListener('dragstart', e => e.preventDefault());

  // Dialogs
  $$('[data-dialog]').forEach(b => b.addEventListener('click', () => $('#' + b.dataset.dialog).showModal()));
  $$('dialog').forEach(d => { d.addEventListener('click', e => { if (e.target === d) d.close(); }); $$('[data-close]', d).forEach(b => b.addEventListener('click', () => d.close())); });
  function refreshZoom() {
    const p = PRODUCTS[state.i], c = colorOf(p, state.color[p.handle]);
    $('[data-zoom-image]').src = c.image; $('[data-zoom-image]').alt = `${p.title} in ${c.name}`;
    $('[data-zoom-title]').textContent = p.title; $('[data-zoom-color]').textContent = c.name;
    const z = $('[data-zoom-swatches]'); z.innerHTML = '';
    if (p.colors.length > 1) p.colors.forEach(col => z.appendChild(swatch(p, col, col.name === c.name)));
  }
  $('[data-zoom]').addEventListener('click', () => { refreshZoom(); $('#zoom-dialog').showModal(); });

  // Bag (Shopify Ajax Cart API)
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = c => new Intl.NumberFormat(undefined, { style: 'currency', currency: data.currency }).format(c / 100);
  const setCount = n => $$('[data-bag-count]').forEach(el => el.textContent = n);
  async function renderBag() {
    const cart = await (await fetch(root + 'cart.js')).json(); setCount(cart.item_count);
    const box = $('[data-bag-content]');
    box.innerHTML = cart.items.length
      ? cart.items.map(it => `<div class="bag-line"><img src="${it.image || ''}" alt="" width="72" height="96"><div><strong>${it.product_title}</strong><span>${it.variant_title || ''} · ${money(it.final_line_price)}</span></div><button type="button" class="text-link" data-remove="${it.key}">Remove</button></div>`).join('') + `<div class="bag-total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>`
      : '<div class="bag-empty"><strong>Your bag is empty.</strong>Pick a silhouette and a color to start your first fit.</div>';
    $$('[data-remove]', box).forEach(b => b.addEventListener('click', async () => {
      await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.remove, quantity: 0 }) }); renderBag();
    }));
  }
  $$('[data-open-bag]').forEach(a => a.addEventListener('click', async e => { e.preventDefault(); await renderBag(); $('#bag-dialog').showModal(); }));
  $('[data-add]').addEventListener('click', async () => {
    const p = PRODUCTS[state.i], color = state.color[p.handle], sel = $('[data-size]');
    const hasSizes = p.variants.some(v => v.size);
    if (hasSizes && !sel.value) { status('Choose a size to add this to your bag.', true); sel.focus(); return; }
    const v = p.variants.find(v => v.color === color && (!hasSizes || v.size === sel.value));
    if (!v || !v.available) { status('That combination is sold out.', true); return; }
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to bag');
      status(`Added: ${p.title} · ${color}${v.size ? ' · ' + v.size : ''}`, true);
      const cart = await (await fetch(root + 'cart.js')).json(); setCount(cart.item_count);
    } catch (err) { status(err.message, true); }
  });

  render(false);
})();
